export default __webpack_public_path__ + "static/media/residencial_14.834c186a.png";